// extracted by mini-css-extract-plugin
export default {"pageWrap":"index_pageWrap__UG+ww","formWrap":"index_formWrap__3JEhB","lotteryItemInput":"index_lotteryItemInput__enjSB","cloneWeekCreate":"index_cloneWeekCreate__e5i6U"};